import React from 'react'
import { Link } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'

const styles = theme => ({
  buttonRootStyle: {
    fontSize: theme.typography.pxToRem(12),
    fontFamily: 'Arial, sans-serif',
    lineHeight: 'normal',
    fontWeight: 'normal',
    textTransform: 'none',
    marginRight: 10,
    marginTop: 14,
    width: 130,
    height: 38,
    backgroundColor: '#e40045',
    borderRadius: 4,
    color: '#fff',
    '&:hover': {
      backgroundColor: '#b10036'
    }
  }
})

const CTAButton = ({
  classes: { buttonRootStyle },
  label = 'Jetzt einsteigen',
  location = '/lions-city'
}) => (
  <Button classes={{ root: buttonRootStyle }} component={Link} to={location}>
    {label}
  </Button>
)

export default withStyles(styles)(CTAButton)



// WEBPACK FOOTER //
// ./src/components/CTAButton.js